module.exports = __webpack_public_path__ + "static/media/oberflex-chenet3-2560x1440.33e9828f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-chenet3-2560x1440.jpg
// module id = 991
// module chunks = 37